// Quoting a post: where it is allowed, and the form under a post that
// Reply and Quote open.

// posts everyone may see, and your own followers-only posts
export const canQuote = ({ status, currentUser, quotingAvailable }) => {
  if (!quotingAvailable || !currentUser || !status) return false
  if (['public', 'unlisted', 'local'].includes(status.visibility)) return true
  return status.visibility === 'private' && status.user?.id === currentUser.id
}

// the form's mode after pressing Reply or Quote: the same one again closes
// it (null), the other one switches it
export const composerMode = (current, pressed) =>
  current === pressed ? null : pressed
